export enum RateChangeMode {
    RATE_UP_ON = 'RATE_UP_ON',
    RATE_DOWN_ON = 'RATE_DOWN_ON', 
    RATE_UP_UNTIL = 'RATE_UP_UNTIL',
    RATE_DOWN_UNTIL = 'RATE_DOWN_UNTIL',
    RATE_SET_ALL = 'RATE_SET_ALL'
} 